@if (required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
    @if (label) {
      <mat-label>{{label}}</mat-label>
    }
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
    <input
      matInput
      class='weaveInput'
      [type]="'email'"
      [disabled]="disabledFlag"
      (keyup.enter)="onFocusOut()"
      (focusout)="onFocusOut()"
      (keyup)="onKeyUp()"
      (keydown.enter)='$event.target.blur()'
      [(ngModel)]='data'
      (focusin)="startEdit()"
      (keydown.escape)="undo()"
      [placeholder]="placeholder"
      [id]="id"
      [maxlength]="maxlength"
      [attr.name]="id"
      required
      email
      #ctrl="ngModel"
      >
      @if (ctrl.hasError('email')) {
        <mat-error>
          Invalid email
        </mat-error>
      } @else if(ctrl.invalid && ctrl.touched) {
        <mat-error>
          {{label || "This field"}} is required
        </mat-error>
      }
      @if (showError && data === '' && required) {
        <div
          class="weaveFormField_error">
          {{label || "This field"}} cannot be empty
        </div>
      }
    </mat-form-field>
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) {
        <mat-label>{{label}}</mat-label>
      }
      @if (description) {
        <div class="applicationHTML" [innerHTML]="description"></div>
      }
      <input
        matInput
        class='weaveInput'
        [type]="'email'"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [id]="id"
        [maxlength]="maxlength"
        [attr.name]="id"
        email
        #ctrl="ngModel"
      >
      @if (ctrl.hasError('email')) {
        <mat-error>
          Invalid email
        </mat-error>
      }
    </mat-form-field>
  </div>
}
